import { ReactNode } from "react";

interface StatsCardLayoutProps {
  children: ReactNode;
  parameters?: ReactNode;
}

export const StatsCardLayout = ({ children, parameters }: StatsCardLayoutProps) => {
  return (
    <div className="border border-neutral-200 rounded-md bg-[#ecf0f3]">
      <div className="grid grid-cols-2 md:grid-cols-4">
        {children}
      </div>
      {parameters && (
        <div className="flex items-center gap-2 border-t bg-white rounded-b-md py-2 flex-wrap">
          {parameters}
        </div>
      )}
    </div>
  );
};

export default StatsCardLayout;
